import React from 'react';
import { Dialog, BUTTON_VARIANTS } from 'cdk-radial';

/**
 * Shared constants for webhook warning dialog
 */
export const WEBHOOK_WARNING_DIALOG = {
  ID: 'webhook-warning-dialog',
  CLOSE_BUTTON_ID: 'webhook-warning-close-button',
  TITLE: 'Webhook URL Required',
  MESSAGE: 'Please set up a valid webhook URL to add locations for this API.',
};

/**
 * WebhookWarningDialog - A reusable dialog component that displays a warning
 * when a user attempts to add locations for an async API without a valid webhook URL.
 * 
 * @param {boolean} isOpen - Controls the visibility of the dialog
 * @param {function} onClose - Callback function to close the dialog
 */
const WebhookWarningDialog = ({ isOpen, onClose }) => {
  return (
    <Dialog
      id={WEBHOOK_WARNING_DIALOG.ID}
      isOpen={isOpen}
      onClose={onClose}
      title={WEBHOOK_WARNING_DIALOG.TITLE}
      buttonsProps={[
        {
          id: WEBHOOK_WARNING_DIALOG.CLOSE_BUTTON_ID,
          onClick: onClose,
          text: 'Close',
          variant: BUTTON_VARIANTS.PRIMARY,
        },
      ]}
    >
      {WEBHOOK_WARNING_DIALOG.MESSAGE}
    </Dialog>
  );
};

export default WebhookWarningDialog;
